import { API_URL, CUSTOMERS_KEY } from '../keys'
import axios from 'axios'

const headers = {
	'sce-api-key': CUSTOMERS_KEY,
	'Content-Type': 'application/json',
}

export const createCartProduct = async (cartData: any, token: string) => {
	const response = await axios.post(`${API_URL}/cart`, cartData, {
		headers: {
			...headers,
			Authorization: `Bearer ${token}`,
		},
		validateStatus: (status) => status < 500,
	})
	return response
}

export const updateCartProductQuantity = async (
	cartId: string,
	productId: string,
	attributeId: string,
	body: { quantity : number},
	token: string
) => {
	const response = await axios.patch(`${API_URL}/cart`, body, {
		params: { cartId, productId, attributeId },
		headers: {
			...headers,
			Authorization: `Bearer ${token}`,
		},
		validateStatus: (status) => status < 500,
	})
	return response
}

export const getCartProducts = async (id: string, token: string) => {
	const response = await axios.get(`${API_URL}/cart/${id}`, {
		headers: {
			...headers,
			Authorization: `Bearer ${token}`,
		},
		validateStatus: (status) => status < 500,
	})
	return response
}

export const deleteCartProductById = async (id: string, token: string) => {
	const response = await axios.delete(`${API_URL}/cart/${id}`, {
		headers: {
			...headers,
			Authorization: `Bearer ${token}`,
		},
		validateStatus: (status) => status < 500,
	})
	return response
}

export const voidCartByCustomer = async (customerId: string, token: string) => {
	const response = await axios.delete(`${API_URL}/cart/void/${customerId}`, {
		headers: {
			...headers,
			Authorization: `Bearer ${token}`,
		},
		validateStatus: (status) => status < 500, 
	})
	return response
}
